import { render, staticRenderFns } from "./EquipmentCreate.vue?vue&type=template&id=71189670&scoped=true"
import script from "./EquipmentCreate.vue?vue&type=script&lang=js"
export * from "./EquipmentCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71189670",
  null
  
)

export default component.exports